// src下创建router目录，并在其中创建index.jsx 创建router配置文件
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import App from '../App15'
import Home from '../App16'
import List from '../App17'
import Detail from '../App18'
const BaseRouter=()=>(
  <BrowserRouter>
  <Routes>
     <Route path='/' element={<App />}>
      <Route path='/home' element={<Home />}></Route>
      <Route path='/list/:id' element={<List />}></Route>
      <Route path='/detail' element={<Detail />}></Route>
      <Route path="*" element={<App />} />
     </Route>
  </Routes>
  </BrowserRouter>
)
export default BaseRouter
